// MenuContent.js
import React from 'react';
import OrganisationSetup from './OrganisationSetup'; 
import CustomTabs from './CustomTabs';
import UserComponent from './User';
import Recyclebin from './RecycleBin';
import Groups from './Groups';
import { useNavigate } from 'react-router-dom';
import TriggersList from '../Object/TriggersList';
import ClassesList from './ClassesList';
import AppManager from './AppManager';
import ApprovalProcess from '../ApprovalProcesses/ApprovalProcess';
import EmailTemplate from './EmailTemplate';
import AccessPolicy from '../Access Policy and Groups/AccessPolicy';
import AccessPolicyGroup from '../Access Policy and Groups/AccessPolicyGroup';
import DashboardList from './DashboardList';
import Roles from '../Access Policy and Groups/Roles';
import ScheduleClass from './ScheduleClass';
import ManageCurrency from './ManageCurrency';
import AuditLogs from './AuditLogs';
import OrganisationWideDefaults from './OrganisationWideDefaults';
import Tabs from './CustomTabs';
import PipelineTable from './PipelineTable';
//import Models from './Model';
import Datable from '../Object/ObjectSetupView';
import PluginsList from './PluginsList';

const MenuContent = ({ selectedItem }) => {

  const navigate = useNavigate();

  switch (selectedItem) {
    case 'Users':
      return <UserComponent />; // Component for Settings
    case 'Object Manager':
      return <Datable />;
    case 'Import Wizard':
      return navigate(`/setup/import`);
    case 'Access Policy':
      return <AccessPolicy/>  
    case 'Access Policy Group':
      return <AccessPolicyGroup/> 
    case 'Custom Tabs':
      return <Tabs />; // Component for Reports
    case 'Pipelines':
      return <PipelineTable />; // Component for Reports
    case 'Recycle bin':
      return <Recyclebin />
    case 'Groups':
      return <Groups/>
    case 'Approval Process':
      return <ApprovalProcess /> 

    case 'System Connectors':
      return navigate(`/setup/SystemConnectors`);
    case 'Custom Connectors':
      return navigate(`/setup/CustomConnectors`);
    case 'Reports':
      return navigate(`/setup/Reports`);
    // case 'Triggers':
    //   return <TriggersList showAllTriggers ={true}/>
    case 'Roles':
      return <Roles/>
    // case 'Models':
    //   return <Models />; // Use the new Models component
    case 'Manage Currency':
      return <ManageCurrency/>
    case 'Audit Logs':
      return <AuditLogs/>
    case 'Classes':
      return <ClassesList/>
    case 'App-Manager':
      return <AppManager/>
    case 'Schedule Jobs':
      return <ScheduleClass />; // Use the new OrganisationSetup component  
    case 'Email Template':
      return <EmailTemplate/>  
    case 'Dashboards':
      return navigate(`/setup/DashboardList`);
    case 'Organisation Setup':
        return <OrganisationSetup />; // Use the new OrganisationSetup component 
    case 'Organisation-Wide Defaults':
      return <OrganisationWideDefaults />;
    case 'Plugins':
      return <PluginsList/>
    default:
      return <div>Select an item from the sidebar</div>;
  }
};




export default MenuContent;